import React from 'react';

import DesktopLayoutUI from './DesktopLayout';
import { useVariant } from '../../context/VariantContext';

const DesktopLayoutMap = () => {
  const variant = useVariant();

  return <DesktopLayoutUI variant={variant} />;
};

export default DesktopLayoutMap;
